import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ReactComponent as LeftIcon } from './auth-img-left.svg'
import { ReactComponent as RightIcon } from './auth-img-right.svg'

export default function AuthBackGround() {
  const { t } = useTranslation()
  return (
    <div className='min-h-screen relative flex items-center justify-center bg-[#F1F4FB]'>
      {/* Background Image */}
      <div className='absolute top-0 left-0 sm:w-1/7 sm:h-1/4 animate__animated  animate__rotateInDownLeft'>
        <LeftIcon className='w-full h-full object-contain text-secondary' />
      </div>
      {/* Bottom Left Image */}
      <div className='absolute bottom-0  right-0 w-1/8 h-1/5  animate__animated  animate__rotateInDownRight'>
        <RightIcon className='w-full h-full object-contain text-primary' />
      </div>
      <Suspense fallback={<>{t('Loading')}...</>}>
        <Outlet />
      </Suspense>
    </div>
  )
}
